import React from 'react';
import { motion } from 'framer-motion';
export function EliteDetail() {
  return <section className="py-16 px-4 bg-mystic-800 relative" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-87">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-lg text-gold-400 font-medium" data-id="element-88">
            Por solo $9.000 más, dejás de entender el problema y empezás a
            cambiar el juego
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-mystic-900 border border-gold-500/30 rounded-2xl p-8 shadow-lg" data-id="element-90">
            <div className="text-4xl mb-4" data-id="element-91">🛡️</div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-92">
              Élite 1 — El Fin de la Disponibilidad
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-93">
              Cómo dejar de ser su Plan B para siempre. El protocolo paso a paso
              para retirar tu energía, subir tu valor percibido y lograr que sea
              ÉL quien tenga miedo de perderte a vos. No más esperar. No más
              estar siempre disponible para alguien que no se decide.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-mystic-900 border border-gold-500/30 rounded-2xl p-8 shadow-lg" data-id="element-94">
            <div className="text-4xl mb-4" data-id="element-95">🔥</div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-96">
              Élite 2 — El Código de la Obsesión
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-97">
              Psicología inversa y gatillos mentales aplicados al amor. Cómo
              pasar de ser la que espera un mensaje a ser la que invade su mente
              24/7 sin perseguir, sin rogar y sin perder tu eje nunca más.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}